import {NgModule} from '@angular/core';
import {HourPipe, DayPipe, FullDatePipe, ShortDatePipe, DayMonth, DayHourPipe} from './date.pipe';
import { UnitPipe } from './unit.pipe';

@NgModule({
    declarations: [ HourPipe, DayPipe, FullDatePipe, ShortDatePipe, DayMonth, DayHourPipe,UnitPipe ],
    exports: [ HourPipe, DayPipe, FullDatePipe, ShortDatePipe, DayMonth, DayHourPipe,UnitPipe ]
})
export class PipeModule {}
